<script>
	export let gitUrl;
	export let height = 32;
</script>

<div class={$$props.class}>
	<a href={gitUrl} style="height:{height}px">
		{#if gitUrl}
			{#if gitUrl.startsWith('https://github.com')}
				<svg viewBox="0 0 24 24"><path
						d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg>
			{:else if gitUrl.startsWith('https://gitlab.com')}
				<svg
					viewBox="0 0 400 342"
					xmlns="http://www.w3.org/2000/svg"
					class="nav-logo">
					<g fill-rule="evenodd">
						<path
							d="M185.398 341.13l68.013-209.322H117.39L185.4 341.13z"
							class="logo-svg-shape logo-dark-orange-shape" />
						<path
							d="M185.398 341.13l-68.013-209.322h-95.32L185.4 341.128z"
							class="logo-svg-shape logo-orange-shape" />
						<path
							d="M22.066 131.808l-20.67 63.61c-1.884 5.803.18 12.16 5.117 15.744L185.398 341.13 22.066 131.807z"
							class="logo-svg-shape logo-light-orange-shape" />
						<path
							d="M22.066 131.808h95.32L76.42 5.735c-2.107-6.487-11.284-6.487-13.39 0L22.065 131.808z"
							class="logo-svg-shape logo-dark-orange-shape" />
						<path
							d="M185.398 341.13l68.013-209.322h95.32L185.4 341.128z"
							class="logo-svg-shape logo-orange-shape" />
						<path
							d="M348.73 131.808l20.67 63.61c1.884 5.803-.18 12.16-5.117 15.744L185.398 341.13 348.73 131.807z"
							class="logo-svg-shape logo-light-orange-shape" />
						<path
							d="M348.73 131.808h-95.32L294.376 5.735c2.108-6.487 11.285-6.487 13.392 0l40.963 126.073z"
							class="logo-svg-shape logo-dark-orange-shape" />
					</g>
				</svg>
			{:else if gitUrl.startsWith('https://sr.ht')}
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 512 512"><path
						d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z" /></svg>
			{:else}
				<svg viewBox="0 0 114.8625 114.8625">
					<g transform="matrix(1.25,0,0,-1.25,0,114.8625)">
						<g transform="scale(0.1,0.1)">
							<path
								d="M 901.547,500.352 500.355,901.527 c -23.093,23.11 -60.566,23.11 -83.691,0 L 333.363,818.211 439.039,712.535 c 24.559,8.293 52.723,2.727 72.293,-16.847 19.688,-19.696 25.207,-48.102 16.699,-72.75 L 629.887,521.094 c 24.648,8.496 53.066,3.004 72.754,-16.711 27.5,-27.492 27.5,-72.059 0,-99.574 -27.52,-27.516 -72.078,-27.516 -99.61,0 -20.683,20.703 -25.801,51.097 -15.312,76.582 l -95,94.992 0,-249.969 c 6.699,-3.32 13.027,-7.742 18.613,-13.312 27.5,-27.497 27.5,-72.059 0,-99.598 -27.5,-27.488 -72.09,-27.488 -99.57,0 -27.5,27.539 -27.5,72.101 0,99.598 6.797,6.789 14.668,11.925 23.066,15.363 l 0,252.281 c -8.398,3.438 -16.25,8.531 -23.066,15.367 -20.828,20.821 -25.84,51.395 -15.157,76.977 L 292.426,777.285 17.3281,502.211 c -23.10544,-23.129 -23.10544,-60.602 0,-83.711 L 418.539,17.3242 c 23.098,-23.10545 60.559,-23.10545 83.691,0 L 901.547,416.641 c 23.117,23.113 23.117,60.605 0,83.711"
								style="fill-opacity:1;fill-rule:nonzero;stroke:none" />
						</g>
					</g>
				</svg>
			{/if}
		{/if}
	</a>
</div>

<style>
	a {
		padding: 2px;
	}
	svg {
		height: 100%;
		fill: #aaa;
	}
</style>
